import { CheckCircle2, Circle } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { RoadmapWeek, getAllDaysFlat, getDayKey } from "@/lib/roadmapHelpers";
import { cn } from "@/lib/utils";

interface RoadmapDaySelectorProps {
  roadmap: RoadmapWeek[];
  currentDayNumber: number;
  onDaySelect: (dayNumber: number) => void;
  isDayCompleted: (dayKey: string) => boolean;
}

export const RoadmapDaySelector = ({
  roadmap,
  currentDayNumber,
  onDaySelect,
  isDayCompleted,
}: RoadmapDaySelectorProps) => {
  const allDays = getAllDaysFlat(roadmap);

  return (
    <Select
      value={currentDayNumber.toString()}
      onValueChange={(value) => onDaySelect(parseInt(value, 10))}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select a day" />
      </SelectTrigger>
      <SelectContent className="max-h-[300px]">
        {allDays.map((day) => {
          const dayKey = getDayKey(day.week, day.day);
          const isCompleted = isDayCompleted(dayKey);
          const isCurrent = day.absoluteDayNumber === currentDayNumber;

          return (
            <SelectItem
              key={dayKey}
              value={day.absoluteDayNumber.toString()}
              className={cn(
                "cursor-pointer",
                isCurrent && "bg-accent"
              )}
            >
              <div className="flex items-center gap-2 w-full">
                {isCompleted ? (
                  <CheckCircle2 className="h-4 w-4 text-green-500 shrink-0" />
                ) : (
                  <Circle className="h-4 w-4 text-muted-foreground shrink-0" />
                )}
                <span className={cn(
                  "flex-1 truncate",
                  isCompleted && "text-muted-foreground"
                )}>
                  Day {day.absoluteDayNumber}: {day.title}
                </span>
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
};
